import { Box } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { renderMixedMathHtml } from "./math-text";

const MathRichText = ({ children, display = false, fontSize, color, ...props }) => {
  const html = useMemo(
    () => renderMixedMathHtml(children, { displayMode: display }),
    [children, display]
  );
  if (!html) return null;

  return (
    <Box
      className="math-rich-text"
      fontSize={fontSize}
      color={color}
      sx={{
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        letterSpacing: "normal",
        lineHeight: "1.85",
        overflow: "visible",
        "& .katex": {
          fontSize: "1em",
          lineHeight: "normal",
          letterSpacing: "normal",
          display: "inline",
          verticalAlign: "baseline",
          maxWidth: "100%",
        },
        "& .katex-html": {
          whiteSpace: "nowrap",
        },
        "& .katex-display": {
          my: 3,
          overflowX: "auto",
          overflowY: "visible",
          lineHeight: "normal",
        },
        "& .katex-display > .katex": {
          display: "block",
          textAlign: "left",
          whiteSpace: "normal",
        },
      }}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  );
};

export default MathRichText;
